import { css } from '../utils.js';

const styles = css`
    .menu-item {
        border-color: ${ props => props.theme.border };
    }
`;

export default styles;
